
(function(){
  var root = document.getElementById('fb-faithbible-root');
  if(!root) return;
  var slides = root.querySelectorAll('[data-fb-slide]');
  var thumbs = root.querySelectorAll('[data-fb-thumb]');
  var idx = 0;
  function show(i){ idx=(i+slides.length)%slides.length; slides.forEach(function(s,n){s.classList.toggle('is-on',n===idx);}); thumbs.forEach(function(t,n){t.classList.toggle('is-on',n===idx);}); }
  thumbs.forEach(function(t,n){ t.addEventListener('click', function(){ show(n); }); });

  var bundles = root.querySelectorAll('[data-fb-bundle]');
  var ctaTotal = root.querySelectorAll('[data-fb-cta-total]');
  var ctaWas = root.querySelectorAll('[data-fb-cta-was]');
  var selected = root.querySelector('.bundle.is-on') || bundles[0];
  function select(b){
    bundles.forEach(function(x){x.classList.remove('is-on');}); b.classList.add('is-on'); selected=b;
    var c=parseInt(b.getAttribute('data-price'),10); var cmp=parseInt(b.getAttribute('data-compare'),10);
    ctaTotal.forEach(function(el){ el.textContent='$'+(c/100).toFixed(2); });
    ctaWas.forEach(function(el){ el.textContent='$'+(cmp/100).toFixed(2); });
  }
  bundles.forEach(function(b){ b.addEventListener('click', function(){ select(b); }); });

  var cd = root.querySelector('[data-fb-countdown]');
  if(cd){
    var endTs = Date.now ? (new Date()).getTime() + 1000*60*60*0 + 1000*60*23 + 1000*27 : 0;
    var h=cd.querySelector('[data-fb-h]'), m=cd.querySelector('[data-fb-m]'), s=cd.querySelector('[data-fb-s]');
    function tick(){
      var now=new Date().getTime(); var diff=Math.max(0, endTs-now);
      var hh=Math.floor(diff/3600000), mm=Math.floor((diff%3600000)/60000), ss=Math.floor((diff%60000)/1000);
      if(h) h.textContent=String(hh).padStart(2,'0'); if(m) m.textContent=String(mm).padStart(2,'0'); if(s) s.textContent=String(ss).padStart(2,'0');
    }
    tick(); setInterval(tick, 1000);
  }

  var tabs = root.querySelectorAll('[data-fb-tabs] .tab');
  tabs.forEach(function(t){ t.addEventListener('click', function(){ tabs.forEach(function(x){x.classList.remove('is-on');}); t.classList.add('is-on'); }); });

  var overlay = document.querySelector('[data-fb-cart-overlay]');
  var drawer = document.querySelector('[data-fb-cart-drawer]');
  var linesEl = document.querySelector('[data-fb-cart-lines]');
  var emptyEl = document.querySelector('[data-fb-cart-empty]');
  var subtotalEl = document.querySelector('[data-fb-cart-subtotal]');
  var countEl = document.querySelector('[data-fb-cart-count]');
  function openCart(){ overlay.classList.add('is-open'); drawer.classList.add('is-open'); }
  function closeCart(){ overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); }
  document.querySelector('[data-fb-open-cart]').addEventListener('click', openCart);
  document.querySelector('[data-fb-close-cart]').addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);

  function renderCart(cart){
    linesEl.innerHTML='';
    if(!cart.items.length){ emptyEl.style.display='block'; }
    else { emptyEl.style.display='none'; cart.items.forEach(function(item){ var row=document.createElement('div'); row.className='fb-cart-line'; row.innerHTML='<img src="'+(item.image||'')+'" alt=""><div><div class="fb-cl-title">'+item.product_title+'</div><div class="fb-cl-price">Qty '+item.quantity+' · $'+(item.final_line_price/100).toFixed(2)+'</div></div>'; linesEl.appendChild(row); }); }
    subtotalEl.textContent='$'+(cart.total_price/100).toFixed(2);
    countEl.textContent = cart.item_count ? '('+cart.item_count+')' : '';
  }
  function addToCart(){
    var id = root.getAttribute('data-variant-id');
    var qty = selected ? parseInt(selected.getAttribute('data-qty'),10) : 1;
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id:id, quantity: qty }] }) })
      .then(function(){ return fetch('/cart.js'); }).then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); openCart(); }).catch(function(){ openCart(); });
  }
  root.querySelectorAll('[data-fb-add]').forEach(function(btn){ btn.addEventListener('click', addToCart); });
  document.querySelector('[data-fb-checkout]').addEventListener('click', function(){ window.location.href='/checkout'; });
  fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
})();
